import { Accordion, AccordionDetails, AccordionSummary, AppBar, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Paper, Toolbar, Typography } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import MyTable, { TableRow } from "../../../components/MyTable";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { getCouponsTypes, setCouponUpdatedData } from "../../../store/slices/userRequests";
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { S10CouponsTypesResponse } from "../../../interfaces/s10Employees.interface";
import MyTextField from "../../../components/MyTextField";
import ListFilesToUpload from "../../../components/ListFilesToUpload";

import { ColorPicker } from 'primereact/colorpicker';

import './index.css'
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import { updateCouponTypeImageRequest, updateCouponTypeRequest } from "../../../api/s10DocumentsApi";
import MySnackbar from "../../../components/MySnackbar";
import { LoadingButton } from "@mui/lab";
import { addOrUpdateGroupId } from "../../../api/fileStorage";

import RefreshIcon from "@mui/icons-material/Refresh";
import { signalGetCouponstData } from "../../../api/signalApi";

const couponsTypes = [{
    title: "Cupones automáticos",
    type: 0,
    filter: (c: any) => c.CouponType === 0,
}, {
    title: "Cupones libres",
    type: 1, 
    filter: (c: any) => c.CouponType !== 0,
}];

interface ButtonBarProps {
    onRefresh: () => void;
    loading: boolean
}

const ButtonBar: React.FC<ButtonBarProps> = ({ onRefresh, loading }) => {

    return (
        <AppBar 
            position="static" 
            elevation={1} 
            style={{
                backgroundColor: "#EFF4F6",
                height: "2rem",
                minHeight: "2.5rem",
                marginBottom: "1rem"
            }}
        >
            <Toolbar sx={{ minHeight: '2.5rem', '@media (min-width:600px)': { minHeight: '2.5rem' } }}>
                <Typography variant="body1" component="div" sx={{ flexGrow: 1 }}>
            </Typography>
            <LoadingButton 
                size="small"
                loading={loading}
                startIcon={<RefreshIcon />} 
                variant="contained" 
                color="primary" 
                onClick={() => {
                    if (loading) {
                        return;
                    }
                    onRefresh()
                }}
            >
                Actualizar
            </LoadingButton>
            </Toolbar>
        </AppBar>
    );
  };


const Coupons = () => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    const [couponTypeSelected, setCouponTypeSelected] = useState<number[]>(couponsTypes.map(c => c.type));
    const [couponToEdit, setCouponToEdit] = useState<S10CouponsTypesResponse | null>(null);
    const [file, setFile] = useState<File[]>([]);
    const [color, setColor] = useState<any>(null);
    const [forcedAttach, setForcedAttach] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [successMsg, setSuccessMsg] = useState<string>("");
    const [loadingImportingCouponData, setLoadingImportingCouponData] = useState(false)

    const tableHeadRows = [ {
        label: "Nombre",
        rowKeyName: "CouponName",
        rowStyle: (row: TableRow<string, any>) => {
            return {
                borderRadius: "0.25rem 0rem 0rem 0.25rem",
                borderLeft: `.25rem solid ${row.Color}`
            };
        },
        customValue: (headRow: any, row: TableRow<string, any>) => {
            return (
                <Grid 
                    container 
                    direction="row" 
                    alignItems="center"
                >
                    {/* <Grid item marginRight=".25rem">
                        <img src={BenefitsImg} style={{maxHeight: "2.2rem"}} alt={`coupon-${row.CouponId}`} />
                    </Grid> */}
                    <Grid item>
                        {row.CouponName}
                    </Grid>
                </Grid>
            )
        },
    },{
        label: "Tipo",
        rowKeyName: "CouponType",
        customValue: (_: any, row: any) => {
            return <>{row.CouponType === 0 ? "Automático" : "Libre"}</>
        }
    },{
        label: "Uso",
        rowKeyName: "Uso",
        customValue: (_: any, row: any) => {
            return <>{row.UseType === 0 ? "Días" : "Horas"}</>
        }
    },{
        label: "",
        rowKeyName: "Edit",
        customValue: (_: any, row: TableRow<string, any>) => {

            const handleSetCouponToEdit = () => {
                setCouponToEdit(row as any);
                setColor(row.Color);
                setForcedAttach(row.ForcedAttach);
                setFile([]);
                // TODO: add set active param
                // setActive()
            }

            return (
                <Button
                    variant="contained"
                    color="inherit"
                    onClick={handleSetCouponToEdit}
                    disableElevation
                    style={{
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem"
                    }}
                >
                    <EditIcon />
                </Button>
            )
        }
    }];


    const couponHasChange = (): boolean => {
        return !(
            forcedAttach === couponToEdit?.ForcedAttach && 
            file.length === 0 &&
            color === couponToEdit.Color
        )
    }

    const handlerUpdateImage = async () => {
        if (!couponToEdit) {
            return;
        }
        const result = await uploadFilesToFilestorage(file, setErrorMsg, false);
        if (result === null) {
            setLoading(false);
            return;
        }
        console.log(result)
        const filestorageData = result.filestorageData;
        const fileStorageId = filestorageData[0].Id;
        const updateGroupId = await addOrUpdateGroupId(filestorageData);
        if (updateGroupId?.Type !== 0) {
            setErrorMsg(updateGroupId?.Message || "Error registrando la información en s10.");
            setLoading(false);
            return;
        }
        const resultUpdateImageId = await updateCouponTypeImageRequest(couponToEdit.CouponId, fileStorageId);
        if (resultUpdateImageId?.Type !== 0) {
            setErrorMsg(updateGroupId?.Message || "Error registrando la información de la imagen.");
            setLoading(false);
            return;
        }
        return fileStorageId;
    }

    const handleUpdateCoupon = async () => {
        // TODO: add active field
        if (!couponHasChange() || !couponToEdit) {
            console.log("without changes");
            return;            
        }
        setLoading(true);
        if (file.length) {
            const fileStorageId = await handlerUpdateImage();
            if (!fileStorageId) {
                return;
            }
        }
        const finalData = {
            CouponId: couponToEdit.CouponId,
            Color: color,
            IsActive: true,
            // FileStorageId: fileStorageId,
            ForcedAttach: forcedAttach,
        }
        console.log(finalData)
        const updateResult = await updateCouponTypeRequest(finalData);
        setLoading(false);
        if (!updateResult) {
            setErrorMsg("Ocurrió un error actualizando el cupón.");
            return;
        }
        setCouponToEdit(null);
        dispatch(setCouponUpdatedData(finalData));
        setSuccessMsg("Cupón actualizado.");
        console.log(updateResult)
    }


    const handlecouponTypeSelected = (type: number, value: any) => {
        const filtered = couponTypeSelected.filter(c => c !== type);
        setCouponTypeSelected(filtered.length < couponTypeSelected.length 
            ? filtered 
            : [...couponTypeSelected, type]
        );
    }

    const handleGetCouponsTypes = () => {
        if(requestCoupon.couponsTypesLoading || !companyselected) return;
        dispatch(getCouponsTypes(0, -1));
        // handlerFilterCoupons(isVacation)
    };

    useEffect(() => {
        handleGetCouponsTypes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected]);


    const getCouponsData = async () => {
        setLoadingImportingCouponData(true);
        const {data} = await signalGetCouponstData();
        await new Promise(resolve => setTimeout(resolve, 3000));
        console.log(data)
        if (data?.isSuccess) {
            handleGetCouponsTypes();
            setSuccessMsg("Información de cupones actualizada.");
        } else {
            setErrorMsg(data?.message || "Error importando la data de cupones del ERP")
        }
        setLoadingImportingCouponData(false);
    }


    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem",
                    height: "100%",
                    marginBottom: "0"
                }}
            >
                <ButtonBar onRefresh={getCouponsData} loading={loadingImportingCouponData} />
                {couponsTypes.map((child, ii) =>(
                    <Accordion
                        key={`${ii}`}
                        expanded={couponTypeSelected.includes(child.type)}
                        onChange={(value) => handlecouponTypeSelected(child.type, value)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                            style={{
                                backgroundColor: "#EFF4F6",
                                height: "3rem",
                                minHeight: "3rem",
                            }}
                        >
                            <Typography variant="h6" fontSize="1rem">{child.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid style={{padding: "1rem 0"}}>
                            {couponTypeSelected.includes(child.type) && 
                                <MyTable
                                    key="tab-0"
                                    hiddenSearchInput={true}
                                    tableHeadRows={tableHeadRows}
                                    tableRows={requestCoupon.couponsTypes.filter(child.filter)}
                                    loading={false}
                                    onlyTable={true}
                                    tableOptionsBar={{
                                        useDrawer: true,
                                    }}
                                />
                            }
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Paper>
        {couponToEdit !== null && <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%", zIndex: 1200}}
            sx={{
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "25rem", 
                  maxWidth: "25rem", 
                },
              },
            }}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Editar cupón
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Grid
                    container
                    // direction="column"
                    // spacing="1.5rem"
                    columnSpacing="1.5rem"
                    rowSpacing="1rem"
                >
                    <Grid item xs={12}>
                        <MyTextField
                            label="Nombre" 
                            value={couponToEdit?.CouponName}
                            style={{width: "100%"}}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <MyTextField
                            label="Código ERP" 
                            value={couponToEdit?.ERPClasification}
                            style={{width: "100%"}}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} height="2.5rem">
                        <Typography 
                            // variant="caption"
                            align='left'
                            style={{
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                                
                            }}
                        >
                            Color
                        </Typography>
                        <Grid container direction="row" alignItems="center" justifyContent="flex-start">
                            <Grid item height="2.5rem" marginRight=".5rem">
                                <Typography lineHeight="2.5rem">
                                    {color}
                                </Typography>
                            </Grid>
                            <Grid item height="2.5rem">
                                <ColorPicker
                                    format="hex"
                                    inputStyle={{
                                        marginTop: ".5rem",
                                        width: "1.5rem",
                                        height: "1.5rem",
                                    }}
                                    value={color} onChange={(e) => setColor(`#${e.value}`)}
                                    panelStyle={{zIndex: "1300 !important", backgroundColor: "white"}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel
                            value="top"
                            control={<Checkbox 
                                checked={forcedAttach}
                                onChange={() => setForcedAttach(!forcedAttach)}
                             />}
                            label="Adjuntar archivo"
                            labelPlacement="top"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel
                            value="top"
                            control={<Checkbox 
                                checked={active}
                                onChange={() => setActive(!active)}
                             />}
                            label="Activo"
                            labelPlacement="top"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ListFilesToUpload
                            setSelectedFiles={setFile}
                            selectedFiles={file}
                            buttonLabel="cargar imagen"
                            accept="image/*"
                            filesLimit={1}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setCouponToEdit(null)}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <LoadingButton 
                            loading={loading}
                            disabled={!couponHasChange() || loading}
                            variant="contained" 
                            style={{minWidth: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleUpdateCoupon}
                        >
                            Actualizar
                        </LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        <MySnackbar
            open={successMsg !== ""}
            onClose={() => setSuccessMsg("")}
            msg={successMsg}
            severity="success"
        />
        <MySnackbar
            open={errorMsg !== ""}
            onClose={() => setErrorMsg("")}
            msg={errorMsg}
            severity="error"
        />
        </Grid>
    )
}

export default Coupons;